<template>
  <div class="loader-wrp">
    <span class="icon">
      <slot>
        <i :class="['fa-solid', 'fa-spinner', 'fa-spin', ...iClasses]" />
      </slot>
    </span>
    <slot name="text">
      <!-- <div class="text">loading</div> -->
    </slot>
  </div>
</template>

<script>
import { computed } from 'vue'
export default {
  name: 'Loader',
  props: {
    iconClasses: { type: [Array, String], default: () => '' },
  },
  setup(props) {
    const iClasses = computed(() =>
      typeof props.iconClasses === 'string'
        ? props.iconClasses.split(' ')
        : props.iconClasses,
    )
    return { iClasses }
  },
}
</script>

<style lang="scss" scoped>
.loader-wrp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0.3;

  .icon {
    width: fit-content;
    height: auto;

    &:has(+ *) {
      margin-bottom: 1.5rem;
    }
  }
}
</style>
